import React, { useState } from 'react';
import { Container, Typography, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import FileUploader from './FileUploader';
import MigrationPanel from './MigrationPanel';

const CSVMigrator = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([]);

  const handleCsvDataLoaded = (data, headers) => {
    setCsvData(data);
    setCsvHeaders(headers);
  };

  return (
    <Container maxWidth="xl">
      <Box py={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          CSV Migration Tool
        </Typography>

        <FileUploader
          onFilesSelected={setSelectedFiles}
          selectedFiles={selectedFiles}
          onCsvDataLoaded={handleCsvDataLoaded}
        />

        {selectedFiles.map((file, index) => (
          <MigrationPanel key={index} file={file} />
        ))}

        {csvData.length > 0 && (
          <Paper elevation={2} sx={{ mt: 3, p: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h5">CSV Preview</Typography>
              <Chip label={`Total Records: ${csvData.length}`} color="primary" size="large" />
            </Box>
            <TableContainer sx={{ maxHeight: 500, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#1976d2', color: '#fff', whiteSpace: 'nowrap', minWidth: 40 }}>#</TableCell>
                    {csvHeaders.map((header, i) => (
                      <TableCell key={i} sx={{ fontWeight: 'bold', bgcolor: '#1976d2', color: '#fff', whiteSpace: 'nowrap' }}>
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {csvData.map((row, rowIndex) => (
                    <TableRow key={rowIndex} sx={{ bgcolor: rowIndex % 2 === 0 ? '#fafafa' : '#fff', '&:hover': { bgcolor: '#e3f2fd' } }}>
                      <TableCell sx={{ color: '#9e9e9e', fontSize: '0.75rem' }}>{rowIndex + 1}</TableCell>
                      {csvHeaders.map((_, cellIndex) => (
                        <TableCell key={cellIndex} sx={{ whiteSpace: 'nowrap', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {row[cellIndex] ?? ''}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>
    </Container>
  );
};

export default CSVMigrator;
